module.exports = __webpack_public_path__ + "static/media/check-square-solid.b3a00b3b.svg";